import { createSelector } from '@ngrx/store'
import { RootState } from '../root.model'
import { PersistentRedux } from './persistent-state.reducer'

const persistentState = (state: RootState) => state.persistent

export const selectExtFileViewerDateRangeFilter = createSelector(
  persistentState,
  (state: PersistentRedux) => ({
    beginDate: state.extFileViewerDateRange?.beginDate,
    endDate: state.extFileViewerDateRange?.endDate,
  }),
)

export const selectExtFileManagerFilter = createSelector(
  persistentState,
  (state: PersistentRedux) => ({
    accountId: state.extFileManagerFilter.accountId,
    activePanelId: state.extFileManagerFilter.activePanelId,
    executionNumber: state.extFileManagerFilter.executionNumber,
    selectedDate: state.extFileManagerFilter.selectedDate,
  }),
)
